export default "__VITE_ASSET__BRCOhnir__ 54w";